
import { defineComponent } from "vue";

export default defineComponent({
  name: "LogoIcon",
  props: ["height", "width", "fill", "startAnimation", "endAnimation"],
});
